import React from 'react';
import { Navigate } from 'react-router-dom';

// /sign-up is a legacy MMS-era route that old emails and bookmarks still
// point at. Anyone following a "sign up" link carries registration intent,
// so it forwards to the live fall funnel. Decided by Anthony 2026-08-18
// (QA-walkthrough follow-up §0); it pointed at /contact while /register was
// deliberately unlinked, a premise that expired with the 08-08 fall push.
// The route stays noindexed (utils/noindexRoutes.js).
const SignUp = () => {
	return <Navigate to='/register' replace />;
};

export default SignUp;
